import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { classNames } from '../../utils/v4/utils';

export default class FontForm extends Component {
  state = {
    showErrors: false,
    errors: {
      name: null,
    },
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { showErrors } = this.state;

    if (showErrors) {
      this.validate(nextProps);
    }
  }

  onChange = event => {
    const { onChange } = this.props;

    onChange(event.target.name, event.target.value);
  };

  onChangeCheckbox = event => {
    const { onChange } = this.props;

    onChange(event.target.name, event.target.checked);
  };

  errorClass = error => (error ? 'error' : null);

  validate = nextProps => {
    const props = nextProps || this.props;
    const {
      font: { name },
    } = props;
    const errors = {};

    if (!name || !name.trim()) {
      errors.name = 'This field cannot be empty.';
    } else if (!this.isUniqueName(props)) {
      errors.name = 'This is already in use.';
    }

    this.setState({ showErrors: true, errors });

    return !errors.name;
  };

  submit = event => {
    const { onUpdate } = this.props;

    event.preventDefault();

    if (this.validate()) {
      onUpdate();
    }
  };

  isUniqueName = props =>
    !props.fonts.some(item => {
      const name = props.font.name.toLowerCase().trim();
      const itemName = item.name.toLowerCase().trim();

      return item.id !== props.font.id && itemName === name;
    });

  render() {
    const {
      auth: {
        user: {
          permissions: { Writer },
        },
      },
      fonts,
      font,
      onCancel,
    } = this.props;
    const { errors } = this.state;

    if (!fonts || !font) {
      return null;
    }

    return (
      <div
        id="edit"
        className="form-signs lg:col-span-8 mt-4 bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-200 p-8 md:p-12"
      >
        <form onSubmit={this.submit}>
          <Grid fluid>
            <Row>
              <Col md={6} className="space-y-6">
                <div>
                  {this.errorClass(errors.name) && (
                    <span className="text-sunrise font-bold  mt-1 mb-4">{errors.name}</span>
                  )}
                  <div
                    className={classNames(
                      'relative group',
                      this.errorClass(errors.name) ? 'mt-2' : '',
                    )}
                    data-test="fontform-form-group"
                  >
                    <label
                      htmlFor="font-input-name"
                      className=" form-label text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
                    >
                      Name
                    </label>
                    <input
                      id="font-input-name"
                      data-test="input-name"
                      type="text"
                      name="name"
                      value={font.name}
                      onChange={this.onChange}
                      disabled={!Writer || font.default}
                      className="w-full text-xl font-bold px-2 py-3 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none"
                    />
                  </div>
                </div>
                <div className="relative group" data-test="fontform-form-group">
                  <label
                    htmlFor="font-description"
                    className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 absolute -top-2 left-6 bg-white px-2 transition-all group-focus-within:text-warmth"
                  >
                    Test drive
                  </label>
                  <textarea
                    id="font-description"
                    data-test="input-testdrive"
                    rows="2"
                    name="description"
                    className={`w-full text-sm  px-6 py-5 rounded-2xl border border-gray-200 focus:border-warmth focus:ring-0 transition-all outline-none resize-none font font-${font.id}`}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="flex items-center">
                  <input
                    id="default-font-checkbox"
                    data-test="checkbox-defaultfont"
                    type="checkbox"
                    name="shouldBeDefault"
                    checked={font.shouldBeDefault}
                    onChange={this.onChangeCheckbox}
                    disabled={!Writer}
                  />
                  <label htmlFor="default-font-checkbox" className="cursor-pointer">
                    Default font
                  </label>
                </div>
              </Col>
            </Row>
          </Grid>
          <div className="pt-6 flex flex-col sm:flex-row gap-4">
            {Writer && (
              <button
                className="flex-1 bg-btn-primary-form text-white px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-black/20"
                data-test="button-update"
                type="submit"
              >
                Update Font
              </button>
            )}
            <button
              type="button"
              className="px-8 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs text-gray-400 hover:text-black transition-colors border border-transparent hover:border-gray-200"
              data-test="button-cancel"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    );
  }
}

FontForm.propTypes = {
  auth: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  fonts: PropTypes.array,
  font: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
